export function delay(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export function fetchWithMinDuration<T>(promise: Promise<T>, ms: number) {
  return Promise.all([promise, delay(ms)]).then(([result]) => result);
}
